import TestWebComponent from './Test';
import ButtonComponent from './Button';
import AppFeatureComponent from './AppFeature';
import { CarouselV2Component } from './CarouselV2';
import FavoriteIconComponent from './FavoriteIcon';
import SectionHeaderComponent from './SectionHeader';
import VenueCarouselComponent from './VenueCarousel';
import PromotionalComponent from './PromotionalComponent';
import PromotionalHeroBannerComponent from './PromotionalHeroBanner';
import { VenueCardComponent, FavoriteVenueCardComponent, HouseholdMemberCardComponent, CompetitionProfileMemberCard } from './Cards';
import AppDownloadBannerComponent from './AppDownloadBanner';
import EmailConsentBoxComponent from './EmailConsentBox';
import { BasicModal, FormModal, TooManyFavouriteModal, SignupMpdal } from './Modal';
import OverlayModal from './OverlayModal';
import YouTubeShortsComponent from './YouTubeShorts';
import YouTubeShortCarouselComponent from './YouTubeShortCarousel';
import IconComponent from './Icon';
import SectionBlockComponent from './SectionBlock';
import InfoScreenHeaderComponent from './InfoScreenHeader';
import SpotlightCardComponent from './SpotlightCard';
import EditCardInfoComponent from './EditCardInfo';
import ConfirmSectionComponent from './ConfirmSection';
import CounterComponent from './Counter';
import SnackbarComponent from './Snackbar';
import ErrorSnackbarComponent from './ErrorSnackbar';
import SuccessScreenComponent from './SuccessScreen';
import PackageCardComponent from './PackageCard';
import CarouselPaginationComponent from './CarouselPagination';

const customComponents = [
	TestWebComponent,
	CarouselV2Component,
	FavoriteIconComponent,
	PromotionalHeroBannerComponent,
	SectionHeaderComponent,
	VenueCarouselComponent,
	AppFeatureComponent,
	PromotionalComponent,
	VenueCardComponent,
	FavoriteVenueCardComponent,
	HouseholdMemberCardComponent,
	CompetitionProfileMemberCard,
	ButtonComponent,
	AppDownloadBannerComponent,
	BasicModal,
	FormModal,
	TooManyFavouriteModal,
	SignupMpdal,
	OverlayModal,
	EmailConsentBoxComponent,
	YouTubeShortsComponent,
	YouTubeShortCarouselComponent,
	IconComponent,
	SectionBlockComponent,
	InfoScreenHeaderComponent,
	SpotlightCardComponent,
	EditCardInfoComponent,
	ConfirmSectionComponent,
	CounterComponent,
	SnackbarComponent,
	ErrorSnackbarComponent,
	SuccessScreenComponent,
	PackageCardComponent,
	CarouselPaginationComponent
];

customComponents.forEach((component) => {
	if (!component.key) {
		console.error(`Component ${component.name} is missing a key`);
		return;
	}

	if (!customElements.get(component.key)) {
		customElements.define(component.key, component);
	}
});

export default customComponents;
